import { FC } from 'react';
import { useResponsive } from 'v3/common/hooks/useResponsive';
import { getData } from '../configs';
import Lottie from 'lottie-react';
import _ from 'lodash';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const locale = ApplicationDomainUtility.locale;
const chess = getData(locale, 'chess');

type ChessProps = {
  productName: string;
};

const Chess: FC<ChessProps> = ({ productName }) => {
  const isMobile = useResponsive();
  return (
    <div className="row strategy-tools__card">
      <div className="card card-blue">
        <h3>We&apos;ve got 80+ Indicators</h3>
        <p>
          {_.capitalize(ApplicationDomainUtility.partnerName) || productName} offers access to over 80 technical indicators
          to help traders design robust algo trading strategies. Customize and combine multiple indicators to
          build, test, and optimize your own algo trading setups.
        </p>

        <ul>
          <li>Build algorithmic strategies with technical indicators</li>
          <li>Customize indicator parameters for precision</li>
          <li>Combine multiple signals for high-probability trades</li>
        </ul>
        {!isMobile && <Lottie animationData={chess} loop className="chess-lottie" />}
      </div>
    </div>
  );
};

export default Chess;
